import { IconTrash } from "@tabler/icons-react";
import { IconButton, Stack, Switch, Text } from "@/components/ui";
import type { EstadoDisenador } from "../../../hooks/use-estado-disenador";
import type { Conexion, EventoDelCatalogo } from "../../../services/notificaciones-service";
import { CondicionEditor } from "./CondicionEditor";
import { EncabezadoPanel } from "./PanelPropiedades";

/** Conexión evento → notificación: activa/inactiva y condición sobre los datos del evento. */
export function PanelConexion({ conexion, disenador: d, catalogo }: { conexion: Conexion; disenador: EstadoDisenador; catalogo: EventoDelCatalogo[] }) {
  const nodo = d.estado.eventos.find((e) => e.clave === conexion.eventoClave);
  const evento = catalogo.find((e) => e.codigo === nodo?.tipoEvento);
  const notificacion = d.estado.notificaciones.find((n) => n.clave === conexion.notificacionClave);

  return (
    <div>
      <EncabezadoPanel
        titulo="Conexión"
        subtitulo={`${evento?.nombre ?? nodo?.tipoEvento ?? "?"} → ${notificacion?.nombre ?? "?"}`}
        acciones={
          <IconButton size="sm" aria-label="Quitar conexión" title="Quitar conexión" onClick={() => d.quitar(conexion.clave)}>
            <IconTrash />
          </IconButton>
        }
      />
      <Stack gap="md" className="p-4">
        <Switch
          label="Conexión activa"
          description="Inactiva: el evento no dispara esta notificación (sin borrarla)."
          checked={conexion.activa}
          onCheckedChange={(activa) => d.actualizarConexion(conexion.clave, { activa })}
        />
        <div>
          <Text size="xs" fw={600} c="dimmed" tt="uppercase" className="mb-1.5">Condición</Text>
          <CondicionEditor
            condicion={conexion.condicion}
            variables={evento?.variables ?? []}
            onCambio={(condicion) => d.actualizarConexion(conexion.clave, { condicion })}
          />
        </div>
      </Stack>
    </div>
  );
}
